import { handle } from 'redux-pack';
import { CREATE_SUPERVISOR, RESETPASSWORD_SUPERVISOR, GET_SUPERVISORS } from '../actions/types';
import { parserSupervisor } from '../utils/parsers';
import { initialPagination } from '../utils/utils';

const initialState = {
	supervisors: [],
	pagination: initialPagination,
	isLoadingSupervisors: false,
	isCreatingSupervisor: false,
	isResettingPassword: false,
	newPassword: ""
};

const supervisorsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SUPERVISORS:
			return handle(state, action, {
				start: (prevState) => ({ ...prevState, isLoadingSupervisors: true }),
				success: (prevState) => ({
					...prevState,
					isLoadingSupervisors: false,
					supervisors: action?.payload?.data?.users?.map((item) => parserSupervisor(item)),
					pagination: {
						...prevState.pagination,
						current: action?.payload?.data?.page,
						total: action?.payload?.data?.totalEntries
					}
				}),
				failure: (prevState) => ({ ...prevState, isLoadingSupervisors: false })
			});

		case CREATE_SUPERVISOR:
			return handle(state, action, {
				start: (prevState) => ({ ...prevState, isCreatingSupervisor: true }),
				success: (prevState) => ({ ...prevState, isCreatingSupervisor: false }),
				failure: (prevState) => ({ ...prevState, isCreatingSupervisor: false })
			});

		case RESETPASSWORD_SUPERVISOR:
			return handle(state, action, {
				start: (prevState) => ({ ...prevState, isResettingPassword: true }),
				success: (prevState) => ({
					...prevState,
					isResettingPassword: false,
					newPassword: action?.payload?.data?.newPassword
				}),
				failure: (prevState) => ({ ...prevState, isResettingPassword: false })
			});

		default:
			return state;
	}
};

export default supervisorsReducer;
